module.exports = __webpack_public_path__ + "img/favorite-two-tone.47441722.svg";